import {
  DoubleLeftOutlined,
  DoubleRightOutlined,
  EllipsisOutlined,
} from '@ant-design/icons';
import React from 'react';

export default function JumpPagePagination({ type, ...props }) {
  return (
    <>
      <a className="jump-page-pagination-custom__wrapper" {...props}>
        <div className="icon_default">
          <EllipsisOutlined />
        </div>
        <div className="icon_hover">
          {type === 'jump-prev' && <DoubleLeftOutlined />}
          {type === 'jump-next' && <DoubleRightOutlined />}
        </div>
      </a>
      <style jsx>{`
        .jump-page-pagination-custom__wrapper {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
        }
        .icon_default {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
        }
        .icon_hover {
          display: none;
          width: 100%;
          height: 100%;
          justify-content: center;
          align-items: center;
          font-size: 14px;
        }

        .jump-page-pagination-custom__wrapper:hover .icon_default {
          display: none;
        }
        .jump-page-pagination-custom__wrapper:hover .icon_hover {
          display: flex;
        }
      `}</style>
    </>
  );
}
